import EndpointProvider from 'contexts/EndpointContext/EndpointProvider';
import FlowProvider from 'contexts/FlowContext/FlowProvider';
import MappingProvider from 'contexts/MappingContext/MappingProvider';
import SchemaProvider from 'contexts/SchemaContext/SchemaProvider';
import UIProvider from 'contexts/UIContext/UIProvider';
import WebServiceProvider from 'contexts/WebServiceContext/WebServiceProvider';
import { combineComponents } from 'utils';

const providers = [EndpointProvider, MappingProvider, SchemaProvider, UIProvider, FlowProvider, WebServiceProvider];
export const AppContextProvider = combineComponents(...providers);
